import { Middleware } from "@nuxt/types";
const authenticated: Middleware = (context: any) => {
  // If the user is not authenticated
  if (!context.store.state.user.authToken && !process.server) {
    context.store.dispatch("user/logout");
  }
};

export default authenticated;
